export function getHeight(): number {
  return window.innerHeight;
}
